import { formatUsdc } from "@breakout/sdk"

export class InsufficientFundsError extends Error {
	constructor(
		public readonly required: number,
		public readonly available: number,
	) {
		super(`Insufficient funds: need $${formatUsdc(required)}, have $${formatUsdc(available)}`)
		this.name = "InsufficientFundsError"
	}
}

export class InsufficientSharesError extends Error {
	constructor(
		public readonly required: number,
		public readonly available: number,
	) {
		super(`Insufficient shares: trying to sell ${required}, have ${available}`)
		this.name = "InsufficientSharesError"
	}
}
